export default function isDomainMatch(domain, hostname) {
  if ( domain === hostname ) {
    return true
  }

  return hostname.endsWith(`.${ domain }`)
}
